import 'url-polyfill';

window.setCookie = (cName, value, exdays) => {
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var cValue=escape(value) + ((exdays==null) ? '' : '; expires='+exdate.toUTCString()) + ';path=/';
  document.cookie=cName + '=' + cValue;
};

window.getCookie = (cName) => {
  var cValue = document.cookie;
  var cStart = cValue.indexOf(' ' + cName + '=');
  if (cStart === -1) {
    cStart = cValue.indexOf(cName + '=');
  }
  if (cStart === -1) {
    cValue = null;
  } else {
    cStart = cValue.indexOf('=', cStart) + 1;
    var cEnd = cValue.indexOf(';', cStart);
    if (cEnd === -1) {
      cEnd = cValue.length;
    }
    cValue = unescape(cValue.substring(cStart,cEnd));
  }
  return cValue;
};

var urlLocation = window.location.toString();
var url = new URL(urlLocation);
var utmSource = url.searchParams.get('utm_source');
var utmMedium = url.searchParams.get('utm_medium');
var utmCampaign = url.searchParams.get('utm_campaign');
var utmTerm = url.searchParams.get('utm_term');
var utmContent = url.searchParams.get('utm_content');

if (utmSource !== null || utmMedium !== null || utmCampaign !== null) {
  window.setCookie('utm_source', utmSource, 30);
  window.setCookie('utm_medium', utmMedium, 30);
  window.setCookie('utm_campaign', utmCampaign, 30);
  window.setCookie('utm_term', utmTerm, 30);
  window.setCookie('utm_content', utmContent, 30);
}

